import { country_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCountryEnum = (enumValue: country_enum) => {
  switch (enumValue) {
    case country_enum.AT:
      return <Trans i18nKey="Enum_CountryEnum-AT" />;
    case country_enum.CZ:
      return <Trans i18nKey="Enum_CountryEnum-CZ" />;
    case country_enum.DE:
      return <Trans i18nKey="Enum_CountryEnum-DE" />;
    case country_enum.FR:
      return <Trans i18nKey="Enum_CountryEnum-FR" />;
    case country_enum.PL:
      return <Trans i18nKey="Enum_CountryEnum-PL" />;
    case country_enum.UK:
      return <Trans i18nKey="Enum_CountryEnum-UK" />;
  }
};

export const translateCountryEnum_dynamic = (enumValue: country_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case country_enum.AT:
      return t('Enum_CountryEnum-AT');
    case country_enum.CZ:
      return t('Enum_CountryEnum-CZ');
    case country_enum.DE:
      return t('Enum_CountryEnum-DE');
    case country_enum.FR:
      return t('Enum_CountryEnum-FR');
    case country_enum.PL:
      return t('Enum_CountryEnum-PL');
    case country_enum.UK:
      return t('Enum_CountryEnum-UK');
  }
};
